import { DBSystemCode } from '@home/_config/config';
import intelligenceAISearchPageSupportConfig from '@intelligence/_config/aiSearchPageSupport';
import opinionsAISearchPageSupportConfig from '@op/_config/aiSearchPageSupport';
import marketingAISearchPageSupportConfig from '@opm/_config/aiSearchPageSupport';

import type { TAISearchPageSupportConfigMap } from '@home/types/aiSearch';

const AI_SEARCH_PAGE_SUPPORT_CONFIG_MAP: TAISearchPageSupportConfigMap = {
  [DBSystemCode.Intelligence]: intelligenceAISearchPageSupportConfig,
  [DBSystemCode.Opinions]: opinionsAISearchPageSupportConfig,
  [DBSystemCode.Marketing]: marketingAISearchPageSupportConfig,
};

export default AI_SEARCH_PAGE_SUPPORT_CONFIG_MAP;
